export enum ActivityState {
  completed = "completed",
  inProgress = "inProgress", // 부분진행
  notStarted = "notStarted", // 진행하지 않음
}

export function getActivityState(rawState: number): ActivityState {
  let activityState: ActivityState | null = null;
  switch (rawState) {
    case 0:
      activityState = ActivityState.notStarted;
      break;
    case 1:
      activityState = ActivityState.inProgress;
      break;
    case 2:
      activityState = ActivityState.completed;
      break;
    default:
      console.error("ActivityState is not valid: " + rawState);
      activityState = ActivityState.notStarted;
      break;
  }
  return activityState;
}

export function getActivityStateStr(state: ActivityState): string {
  switch (state) {
    case ActivityState.notStarted:
      return "common.activityState.notStarted";
    case ActivityState.inProgress:
      return "common.activityState.inProgress";
    case ActivityState.completed:
      return "common.activityState.completed";
  }
}
